<template>
	<div class="relative w-full pt-10 pb-20 px-10">
		<div class="relative w-full flex flex-col justify-center items-start gap-4 z-20">
			<span class="text-xl md:text-2xl lg:text-3xl font-display font-semibold text-brown">
				{{ $t('global.gallery') }}
			</span>

			<div 
				class="relative w-full h-[60vh] grid place-content-center overflow-hidden"
				@mouseenter="startAnimation"
				@mouseleave="stopAnimation"
			>
				<div 
					class="
						cursor-pointer
						absolute top-0 left-0 w-full h-full z-0
						grid grid-rows-2 grid-cols-2 md:grid-cols-3 grid-flow-row
					"
					@click="galleryOpen = true"
				>
					<div 
						v-for="image in galleryPreview"
						:key="image"
						class="gallery-scale bg-cover bg-center"
						:style="{ backgroundImage: `url(${image})` }"
					></div>

					<div
						class="absolute top-0 left-0 w-full h-full crt z-10 opacity-60"
					></div>
				</div>

				<PhotoGallery :gallery-open="galleryOpen" @close="galleryOpen = false" />
			</div>
		</div>
	</div>
</template>

<script>
import { gsap } from 'gsap';
import { galleryPreview } from '../assets/config/galleryConfig';
import PhotoGallery from './graphics/PhotoGallery.vue';

export default {
	name: 'GalleryPage',
	setup() {
		return {
			galleryPreview,
		};
	},
	components: {
		PhotoGallery,
	},
	data() {
		return {
			galleryOpen: false,
		};
	},
	methods: {
		startAnimation() {
			gsap.to('.gallery-scale', {
				scale: 1.2,
				duration: 1,
				ease: 'power2.out',
			});
		},
		stopAnimation() {
			gsap.to('.gallery-scale', {
				scale: 1,
				duration: 1,
				ease: 'power2.out',
			});
		},
	},
};
</script>
